/** Order detail page (pageC/order_detail) messages — English */
export default {
  orderDetail: {
    nav: {
      title: 'Order details',
      tourismTitle: 'Tour order details',
    },
    common: {
      customerService: 'Support',
      copy: 'Copy',
      orderNo: 'Order No.',
      orderNoWithColon: 'Order No.: {orderNo}',
      orderTime: 'Order time: {time}',
      total: 'Total',
      yuan: 'CNY',
      loading: 'Loading',
      tip: 'Notice',
      cancel: 'Cancel',
      next: 'Next',
      or: 'Or unsubscribe products below',
      referenceNote: '*For reference only',
      updateTime: 'Updated: {time}',
      learnMore: 'Learn more',
      mayBeFraud: 'may be a scam',
      openUrl: 'Open URL',
      updatedAt: 'Updated: {time}',
      unionOrderBadge: 'Bundle',
      latestTicketTime: 'Latest ticketing time: {time}',
    },
    payment: {
      payBefore: 'Please pay before {time}',
      payBeforeShort: 'Pay before {time}',
      lockPriceTip: 'Complete payment to lock the price',
      payNow: 'Pay now',
      payPending: 'Pending payment',
      paySoonStock: 'Limited availability — pay soon or the order will be cancelled automatically',
      orderAmount: 'Order amount',
      onlinePay: 'Online payment',
      onlinePayLabel: 'Pay online',
      originalPrice: 'Original: ￥{amount}',
      payablePrice: 'Amount due: ￥{amount}',
      orderAmountDetail: 'Order details',
      prepaidAmount: 'Prepaid amount',
      refundAmount: 'Refund amount',
      couponAmount: 'Coupon amount',
      appendAmount: 'Additional amount',
      cancelAmount: 'Cancellation fee',
      actualPaid: 'Amount paid',
      pendingAppend: 'Amount due',
      totalLabel: 'Total',
    },
    unionPoint: {
      title: 'UnionPay points',
      usePointNum: 'Points used',
      pointAmount: 'Points discount',
      pointRefunded: 'Points refunded',
      pointCount: '{count} pts',
      deductAmount: '-￥{amount}',
    },
    coupon: {
      used: 'Coupons used',
      totalDiscount: 'Total savings',
      discountDetail: 'Coupon discount',
      total: 'Coupon total',
      fallback: 'Coupon',
      noThreshold: 'No minimum',
      fullReduction: 'Spend {minAmount}, save {amount}',
      instantReduction: 'Save {amount} CNY',
      fullDiscount: 'Spend {minAmount}, {discount}% off',
      percentDiscount: '{discount}% off',
    },
    plane: {
      preTravelMustRead: 'Before you travel',
      noticeCount: '3 notices',
      civilizedReminder: 'Civilized travel',
      fraudReminder: 'Fraud alert',
      luggageRules: 'Baggage rules',
      refundLuggage: 'Change, refund & baggage',
      outbound: 'Outbound',
      return: 'Return',
      oneWay: 'One way',
      cancelled: 'Cancelled',
      withMeal: 'Meal included',
      noMeal: 'No meal',
      stopover: 'Stopover: {city}',
      stopoverTime: 'Stopover time: {time}',
      travelInfo: 'Trip info',
      travelers: 'Travelers',
      viewId: 'View ID',
      contactPhone: 'Contact phone',
      changeRejectReason: 'Change rejected reason:',
      changeRejectStatus: 'Change rejected',
      rebook: 'Book again',
      cancelOrder: 'Cancel order',
      refundProgress: 'Refund status',
      applyRefund: 'Request refund',
      issueInvoice: 'Issue invoice',
      viewInvoice: 'View invoice',
      changeDate: 'Reschedule',
      ticketInfo: 'Ticket info',
      ticketNo: 'Ticket No.:',
      flightNo: 'Flight No.:',
      refundPassengers: 'Passengers to refund',
      changePassengers: 'Passengers to reschedule',
      flightNoLabel: 'Flight No.: {flightNum}',
      preTravelPopupTitle: 'Before you travel',
      flightReminder: 'Flight reminders',
      otherReminder: 'Other reminders',
      luggageRulesTitle: 'Baggage rules',
      civilizedTitle: 'Civilized travel',
      fraudTitle: 'Fraud alert',
      luggageIntro: 'What items are prohibited, must be checked, or may be carried on board?',
      civilizedBody:
        'Disruptive behavior on aircraft may result in penalties or criminal liability. Please travel lawfully and courteously.',
      fraudBodyPrefix:
        'Calls claiming flight cancellation or mechanical issues asking you to call back, download apps, or wire money for changes ',
      fraudBodySuffix:
        '. Check your order details or the airline website. Contact support or the airline to verify.',
      orderTransaction: 'Order transactions',
      adult: 'Adult',
      child: 'Child',
      infant: 'Infant',
      planeTicket: 'Flight',
      airportFee: 'Airport fee',
      fuelTax: 'Fuel surcharge',
      changeFee: 'Change fee',
      changeDiff: 'Fare difference',
      priceTimesPerson: '￥{price}×{count} passenger(s)',
      priceTimesShare: '￥{price}×{count}',
      unsubscribe: 'Unsubscribe',
      unsubscribePlane: 'Refund flight',
      unsubscribePlaneDesc: 'Additional products may be refunded together',
      unsubscribeInsurance: 'Refund insurance',
      fuelOnlyRefund: 'Airport & fuel tax only',
      perPerson: '/person',
      refundReason: 'Refund',
      statusChanging: 'Rescheduling',
      statusRefunded: 'Refunded',
      statusRefunding: 'Refunding',
    },
    hotel: {
      cancelRulesBtn: 'Cancel policy',
      viewCancelRules: 'View cancellation policy',
      contactHotel: 'Contact',
      facilitiesPolicy: 'Facilities',
      map: 'Map',
      taxi: 'Ride',
      checkIn: 'Check-in: {date}',
      checkInAfter: 'After {time}',
      checkOut: 'Check-out: {date}',
      checkOutBefore: 'Before {time}',
      roomNights: '{roomName} {roomCount} room(s) {nights} night(s)',
      maxGuests: 'Up to {count} guest(s)',
      remark: 'Remarks: {remark}',
      cancelPolicy: 'Cancellation policy',
      beijingTime: 'Beijing time',
      cancelFee: 'Cancellation fee',
      nonRefundableNotice:
        'No-show fee ¥{amount}. Order is effective after hotel confirmation. Full refund if not confirmed.',
      refundableNotice: '{rule}. After that, non-refundable; no-show fee ￥{amount}.',
      nonRefundable: 'Non-refundable',
      afterBookingSuccess: 'After booking confirmed',
      free: 'Free',
      floorSuffix: 'F',
      areaSuffix: '㎡',
      breakfastDouble: 'Breakfast for two',
      breakfastNone: 'No breakfast',
      breakfastSingle: 'Breakfast for one',
      pendingRefundMsgPrefix:
        'Booking not confirmed yet. Cancellation may incur a fee. Contact support at ',
      pendingRefundPhone: '4007659936 ext. 1001',
      pendingRefundMsgSuffix: ' for assistance.',
      confirmRefund: 'Confirm refund',
    },
    tourism: {
      reservationInfo: 'Booking info',
      costDetail: 'Price breakdown',
      travelers: 'Travelers',
      contactInfo: 'Contact info',
      validTime: 'Validity',
      bookingCount: 'Quantity',
      addonItems: 'Add-ons',
      bookingPackage: 'Package',
      pickupPoint: 'Pickup',
      dropoffPoint: 'Drop-off',
      pickupWithName: 'Pickup {name}',
      dropoffWithName: 'Return {name}',
      codeType: 'Voucher type',
      codeOneOrder: 'One code per order',
      codeNone: 'No code',
      codePerPerson: 'One code per person',
      timeSlot: 'Time slot',
      entryMethod: 'Entry method',
      entryQrExchange: 'Exchange ticket with QR code before entry',
      entryById: 'Entry with ID card',
      entryByPhysical: 'Entry with physical ticket — see logistics below',
      entryByPrint: 'Entry with printout',
      entryByStudentId: 'Entry with student ID',
      voucherTitle: 'Entry voucher',
      voucherKeepSafe: 'Keep your voucher code safe',
      voucherNoLeak: 'Do not share with others',
      voucherPreventLoss: 'to prevent loss',
      voucherCode: 'Code: {code}',
      voucherTraveler: 'Traveler: {name}',
      voucherPackage: 'Package: {planName}',
      copyUrlTip: 'Copy the URL and open in a browser',
      qrUrl: 'QR URL:',
      refundNote: 'Refund policy',
      refundNotSupported: 'Non-refundable',
      refundSupported: 'Refundable',
      refundRuleNotice: 'Subject to the policy shown',
      viewLogistics: 'View logistics',
      logisticsInfo: 'Logistics',
      validitySameDay: 'Valid on {date} after purchase',
      validityUntil: 'Valid until {date} after purchase',
      validityRange: 'Valid from {start} to {end} after purchase',
      productOffShelf: 'Product discontinued',
    },
    taxi: {
      callPolice: 'Call 110',
      contactService: 'Contact support',
      bookAgain: 'Book again',
      returnTrip: 'Return trip',
    },
    markup: {
      infoTitle: 'Surcharge info',
    },
    service: {
      purchased: 'Purchased / complimentary services',
      insurance: 'Insurance',
      more: 'More',
    },
    date: {
      today: 'Today',
      tomorrow: 'Tomorrow',
      dayAfterTomorrow: 'Day after tomorrow',
      sunday: 'Sun',
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      monthDay: '{month}/{day}',
    },
    ticketState: {
      deleted: 'Deleted',
      issued: 'Ticket issued',
      refunded: 'Refunded',
      refunding: 'Refunding',
      reviewing: 'Under review',
      approved: 'Approved',
      reviewFailed: 'Review failed',
      pendingChange: 'Pending reschedule',
      changed: 'Rescheduled',
      changeFailed: 'Reschedule failed',
      changeCancelled: 'Reschedule cancelled',
      cancelled: 'Cancelled',
      notIssued: 'Not issued',
    },
    idType: {
      idCard: 'ID card',
      passport: 'Passport',
      other: 'Other',
      hkmResidence: 'HK/Macau/Taiwan residence permit',
      household: 'Household register',
      homeReturn: 'Home return permit',
      taiwanCompatriot: 'Taiwan compatriot pass',
      military: 'Military ID',
      birthCert: 'Birth certificate',
      tourismIdCard: 'ID card',
      studentId: 'Student ID',
      officerId: 'Officer ID',
      householdChild: 'Household register (for children)',
      hkmPass: 'HK/Macau pass',
      taiwanMainlandPass: 'Taiwan compatriot travel permit',
      taiwanPass: 'Taiwan travel pass',
      taiwanEntry: 'Taiwan entry permit',
      hkMainlandPass: 'HK resident mainland travel permit',
      policeId: 'Police ID',
      driverLicense: 'Driver license',
      seamanCert: 'Seaman certificate',
      foreignPermanent: 'Foreign permanent residence',
      macauMainlandPass: 'Macau resident mainland travel permit',
      hkmMainlandPass: 'HK/Macau resident mainland travel permit',
      hkmTaiwanPass: 'HK/Macau/Taiwan mainland travel permit',
      hkmResidencePermit: 'HK/Macau/Taiwan residence permit',
      travelPermit: 'PRC travel document',
      hkIdCard: 'HK ID card',
    },
    toast: {
      noChangePassenger: 'No passengers eligible for reschedule',
      noRefundableTicket: 'No refundable tickets',
      refundApplySuccess: 'Refund request submitted',
      noRefundableFlight: 'No refundable tickets in this order',
      changingNoRefund: 'Refund not available while rescheduling',
      specialNoRefund: 'This product cannot be refunded',
      productOffShelf: 'Product discontinued — cannot rebook',
      productInfoFailed: 'Failed to load product info',
      networkFailed: 'Network error — please try again',
      cancelSuccess: 'Cancelled',
      wrongAccount: 'This order belongs to another account. Please sign in again.',
    },
    dialog: {
      cancelOrderMsg: 'Cancel this order?',
      interceptRefundApplyMsg:
        'After you submit an intercept request, a successful intercept will result in a full refund. If the intercept fails, you may still travel or submit a refund request again.',
    },
    mapReferer: 'Interest-free travel',
  },
  /** Cart order detail (pageC/order_detail, type=0) */
  cartOrderDetail: {
    title: 'Cart Order Details',
    loading: 'Loading…',
    loadError: 'Failed to load order details',
    reload: 'Reload',
    invalidOrder: 'Invalid order information',
    // Status: orderStatus 0-pending payment, 1-paying, 3-completed, 4-canceled
    statusWaitingPay: 'Pending payment',
    statusPayTimeout: 'Payment timed out',
    statusPaying: 'Payment in progress',
    statusFinished: 'Completed',
    statusCanceled: 'Canceled',
    // Unknown status fallback
    statusDefault: 'Order submitted',
    expireTip: 'to complete payment',
    expiredTip: 'Order expired, please place a new order',
    // Amount
    amountGoodsTotal: 'Goods total',
    amountDiscount: 'Discount',
    amountPayable: 'Payable',
    statusPayAmount: 'Due',
    // Order info
    infoOrderNo: 'Order No.',
    infoCreateTime: 'Created at',
    infoBuyCount: 'Quantity',
    infoCombinedPay: 'Combined payment paid',
    copy: 'Copy',
    copied: 'Copied',
    // Products
    productCount: '{n} items',
    defaultProductName: 'Product',
    // Actions
    payNow: 'Pay now',
    cancelOrder: 'Cancel order',
    cancelConfirmTitle: 'Cancel order',
    cancelConfirmContent: 'Cancel this order?',
    orderCanceled: 'Order canceled',
    cancelFail: 'Failed to cancel, please try again',
    payFail: 'Failed to initiate payment, please try again',
    // Fast pay (direct payment-link fetch) failed — same wording as the order list's cartOrderPayLinkFailed
    payLinkFailed: 'Failed to get the payment link, please try again later',
    // Hotel card info rows (the stay row carries its own wording, no leading label)
    hotelStayRange: 'Check-in {from} · Check-out {to}',
    hotelGuest: 'Guest: ',
    hotelPhone: 'Contact phone: ',
    hotelAddress: 'Address: ',
    // Flight card info rows / itinerary
    flightGuest: 'Passenger(s): ',
    // Flight fare rows: {type} is the passenger-type label; insurance fallback label
    flightFareType: '{type} fare',
    flightInsurance: 'Insurance',
    flightTransfer: '{n} stop(s)',
    flightMultiTrip: 'Multi-city',
    tourismCount: '{n} pcs',
    // Tourism card info rows (labels carry the separator, shown inline with the value)
    tourismTravelDate: 'Travel date: ',
    tourismTravelers: 'Travelers: ',
    tourismContact: 'Contact: ',
    tourismPhone: 'Mobile: ',
    tourismPeopleCount: '{n} pax',
    unitPriceTimesCount: '{price} × {n}',
  },
}
